// 달 — 은은한 추상 광원(원반 + 글로우). 얼굴·테두리·후광 없음(디자인 가드레일).
export default function Moon({ size = 64, glow = true }: { size?: number; glow?: boolean }) {
  return (
    <div className="moon-wrap" style={{ width: size, height: size }}>
      {glow && <div className="moon-glow" />}
      <div className="moon-disc" style={{ width: size, height: size, position: "relative" }} />
    </div>
  );
}
